import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import HighchartsReact from 'highcharts-react-official';
import { find } from 'lodash-es';

import chartTypes from './ChartConfig';

class Chart extends Component {
  static propTypes = {
    chartId: PropTypes.string,
    style: PropTypes.object,
    config: PropTypes.object,
    className: PropTypes.string,
    type: PropTypes.oneOf(['chart', 'stockChart']),
    immutable: PropTypes.bool,
  };
  static defaultProps = {
    type: 'chart',
    immutable: false,
  };

  onChartCreated = (chart) => {
    this.chartRef = chart;
  };

  get containerProps() {
    const { chartId, className, style } = this.props;
    return {
      id: chartId,
      className: cx(className),
      style,
    };
  }

  getPoint = (seriesIndex, name) => find(this.chartAPIRef().series[seriesIndex].data, { name });

  chartAPIRef = () => this.chartRef;

  render() {
    const { type, config, immutable } = this.props;

    return (
      <HighchartsReact
        constructorType={type}
        options={config}
        highcharts={chartTypes(type)}
        callback={this.onChartCreated}
        containerProps={this.containerProps}
        immutable={immutable}
      />
    );
  }
}

export default Chart;
